import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { STATE__generation } from '../STATE__generation';

export function update_user_task_locally(state: STATE__generation, user_task: DTO__user_task) {
  state.user_tasks_map.set(user_task._id, user_task);

  //need to force re-render
  state.user_tasks_map = new Map(state.user_tasks_map);

  if (state.user_task_current._id == user_task._id) {
    state.user_task_current = user_task;
  }
}
